import { SideNavItem, SideNavItems, SideNavSection } from '@modules/navigation/models';

/** Ruta del ítem «Fina Presta». El badge «EN MORA», la visibilidad y su lugar en el menú se atan a ella, no al texto. */
export const CREDITOS_ITEM_LINK = '/creditos/general';

/** ¿Es el ítem de créditos (Fina Presta)? Único predicado del ítem en el menú lateral. */
export const isCreditosItem = (item: SideNavItem | null | undefined): boolean => item?.link === CREDITOS_ITEM_LINK;

/**
 * FINA-3378 (canvas «Box copy»): el ítem de Fina Presta no va en la lista de Módulos sino en el
 * hueco entre esa lista y Configuración. Devuelve el primero que aparezca en las secciones.
 */
export const findCreditosItem = (sections: SideNavSection[] | null | undefined, items: SideNavItems | null | undefined): SideNavItem | null => {
    for (const section of sections ?? []) {
        for (const key of section.items) {
            const item = items?.[key];
            if (isCreditosItem(item)) return item;
        }
    }
    return null;
};
